var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgX = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 9,
    cy: 9.67285,
    r: 7.5,
    fill: "currentColor"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.19375 6.86658C5.93544 7.12489 5.93544 7.54369 6.19375 7.802L8.06463 9.67288L6.19373 11.5438C5.93542 11.8021 5.93542 12.2209 6.19373 12.4792C6.45204 12.7375 6.87084 12.7375 7.12915 12.4792L9.00005 10.6083L10.8708 12.4791C11.1291 12.7374 11.5479 12.7374 11.8063 12.4791C12.0646 12.2208 12.0646 11.802 11.8063 11.5437L9.93547 9.67288L11.8062 7.80212C12.0645 7.54381 12.0645 7.12501 11.8062 6.8667C11.5479 6.60839 11.1291 6.60839 10.8708 6.8667L9.00005 8.73747L7.12917 6.86658C6.87086 6.60827 6.45206 6.60827 6.19375 6.86658Z",
    fill: "white"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgX, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/x.d8f7ad5c.svg";
export { ForwardRef as ReactComponent };